import * as yup from 'yup';
import {EMAIL_PATTERN, MAX_TEXT_FIELD_LENGTH} from '../constants/application.const';

// Customer details validations
export const customerValidation = yup.object({
  name: yup.string().required('Name requried').max(MAX_TEXT_FIELD_LENGTH, `Maximum ${MAX_TEXT_FIELD_LENGTH} allowed`),
  email: yup.string().required('Email required').matches(EMAIL_PATTERN, 'Invalid email'),
}).required();
